import { Heading } from '@/components/base/heading'
import { Connectors } from '@/components/connectors/table'

export const Index = () => {
  return (<div className="flex flex-col gap-3">
    <Heading level={ 1 } size="3xl">Connectors</Heading>
    <Connectors />
  </div>)
}
